import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import EgwWebFont from "src/assets/EgwWebFont";
import { useModalContext } from "@/shared/contexts/modal";
import IconView from "@/shared/components/IconView/IconView";
import { Button, Typography } from "@/components/index";
import CreateQRcode from "../CreateQRcode/CreateQRcode";
import { LANDING_SELECTORS } from "@/utils/landing/landing.constants";

const ButtonQRCode = ({
  withLabel,
  withLabelBeforeIcon,
  className,
  size = "2.2rem",
  isHeaderIcon,
  variant,
}) => {
  const { showModal } = useModalContext();

  const handleButtonClick = () => {
    const url = window.location.origin;
    showModal(<CreateQRcode value={url} />);
  };

  return (
    <Button
      classNameRipple={classNames(LANDING_SELECTORS.btnQR.substring(1), {
        [LANDING_SELECTORS.btnQRSmall.substring(1)]: !isHeaderIcon,
      })}
      className={className}
      variant={variant ? variant : Button.variant.clear}
      color={Button.color.icon}
      onClick={handleButtonClick}
      style={{ height: "auto" }}>
      {withLabelBeforeIcon}
      <IconView
        style={{
          fontSize: size,
          paddingLeft: withLabelBeforeIcon ? "0.5rem" : 0,
        }}
        icon={EgwWebFont[isHeaderIcon ? "qr-code-mobile-menu" : "qr-code"]}
        size={size}
      />
      {withLabel && (
        <Typography color="inherit" style={{ fontWeight: 400 }} variant="h3" fontFamily="bebas">
          &nbsp;QR
        </Typography>
      )}
    </Button>
  );
};

ButtonQRCode.propTypes = {
  className: PropTypes.string,
  withLabel: PropTypes.bool,
  size: PropTypes.string,
};

export default ButtonQRCode;
